/**
 *  HelpScene
 *
 *  Created by Legman on 24/02/2017.
 *
 */

import Common           from "./Common";
import ScanlinesFilter  from "./ScanlinesFilter";

/**
 * @class
 */
export default class HelpScene extends p3.Scene {
    constructor() {
        super();

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._panel = null;

        /**
         * @member {PIXI.Sprite}
         * @private
         */
        this._info = null;

        /**
         * @member {p3.Button}
         * @private
         */
        this._backButton = null;
    }

    init() {
        super.init();

        const assets = Common.assets;

        const bg = new PIXI.Sprite(assets.getTexture("paused_overlay"));
        bg.width = p3.View.width;
        this.addChild(bg);

        this._panel = new PIXI.Sprite(assets.getTexture("paused_panel"));
        this._panel.x = p3.View.width * 0.5;
        this._panel.y = 100;
        this._panel.anchor.x = 0.5;
        this._panel.visible = false;
        this.addChild(this._panel);

        this._panel.stem = new PIXI.Sprite(assets.getTexture("paused_panel_stem"));
        this._panel.stem.anchor.x = 0.5;
        this._panel.addChild(this._panel.stem);

        this._panel.image = new PIXI.Sprite(assets.getTexture("instructions_screen"));
        this._panel.image.x = -14;
        this._panel.image.y = 862;
        this._panel.image.anchor = new PIXI.Point(0.5, 0.5);
        this._panel.image.visible = false;
        this._panel.addChild(this._panel.image);

        const filter = new ScanlinesFilter(this._panel.image);
        this._panel.image.filters = [filter];

        this._info = new PIXI.Sprite(assets.getTexture("instructions_info"));
        this._info.x = p3.View.width * 0.5;
        this._info.y = Common.STAGE_HEIGHT * 0.5 + 400;
        this._info.anchor = new PIXI.Point(0.5, 0.5);
        this._info.visible = false;
        this.addChild(this._info);

        let states = new p3.ButtonStates();
        states.normal = assets.getTexture("btn_small_off");
        states.icon = assets.getTexture("icon_close_off");

        this._backButton = new p3.Button(states);
        this._backButton.visible = false;
        this._backButton.signals.click.add(this.onBackButtonClick, this);
        this.addChild(this._backButton);
    }

    destroy() {
        super.destroy();
    }

    appear() {
        super.appear();
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateIn(callback, scope) {
        // panel
        const to = this._panel.y;
        this._panel.y = -this._panel.height;
        TweenMax.to(this._panel, 0.4, {
            delay: 0.1,
            y: to,
            ease: Back.easeOut,
            easeParams: [0.8],
            onStart: function() {
                this._panel.visible = true;
            },
            onStartScope: this,
            onComplete: function() {
                // panel screen
                this._panel.image.scale.y = 0;
                TweenMax.to(this._panel.image.scale, 0.14, {
                    y: 1,
                    ease: Power2.easeInOut,
                    onStart: function() {
                        this._panel.image.visible = true;
                    },
                    onStartScope: this
                });
                this._panel.image.alpha = 0;
                TweenMax.to(this._panel.image, 0.1, {
                    alpha: 1,
                    ease: Power1.easeInOut
                });
            },
            onCompleteScope: this
        });

        // back button
        this._backButton.scale = new PIXI.Point();
        TweenMax.to(this._backButton.scale, 0.34, {
            delay: 0.1,
            x: 1.0,
            y: 1.0,
            ease: Back.easeOut,
            easeParams: [2],
            onStart: function() {
                this._backButton.visible = true;
            },
            onStartScope: this
        });
    }

    /**
     * @param {function} [callback]
     * @param {*} [scope]
     */
    animateOut(callback, scope) {
    }

    resize() {
        this.y = (p3.View.height - Common.STAGE_HEIGHT) * 0.5;

        this._backButton.x = p3.View.width - 100;
        this._backButton.y = (Common.STAGE_HEIGHT - p3.View.height) * 0.5 + 100;
    }

    update() {
        const filter = this._panel.image.filters[0];
        filter.time -= deltaTime * 4;
    }

    /**
     * @param {p3.Button} button
     */
    onBackButtonClick(button) {
        this.signals.next.dispatch(this);
    }
}
